<div
    class="toastr-container"
    [ngClass]="{
        show: isVisible,
        success: variant === 'success',
        error: variant === 'error',
        warning: variant === 'warning',
        info: variant === 'info'
    }"
>
    <span class="toastr-icon-span">
        <div class="icon-container" *ngIf="variant === 'info'">
            <img
                class="toastr-icon"
                src="../../../../../assets//demo/images/information.png"
            />
        </div>
        <div class="icon-container" *ngIf="variant === 'success'">
            <img
                class="toastr-icon"
                src="../../../../../assets//demo/images/check.png"
            />
        </div>
        <div class="icon-containber" *ngIf="variant === 'error'">
            <img
                class="toastr-icon"
                src="../../../../../assets//demo/images/error.png"
            />
        </div>
        <div class="icon-container" *ngIf="variant === 'warning'">
            <img
                class="toastr-icon"
                src="../../../../../assets//demo/images/warning.png"
            />
        </div>
    </span>
    <div class="flex flex-column ml-3">
        <span class="toastr-title" *ngIf="variant === 'warning'">{{
            "Warning" | translate
        }}</span>
        <span class="toastr-title" *ngIf="variant === 'error'">{{
            "Error" | translate
        }}</span>
        <span class="toastr-title" *ngIf="variant === 'info'">{{
            "Info" | translate
        }}</span>
        <span class="toastr-title" *ngIf="variant === 'success'">{{
            "Success" | translate
        }}</span>
        <span class="toastr-message mt-1">{{ message | translate }}</span>
    </div>
</div>
